import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../../base-control-value-accessor';

@Component({
    selector: 'app-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.scss']
})

export class RadioButtonComponent extends BaseControlValueAccessor<string> {
  @Input() disabled: boolean;
  @Input() option: any;
  @Input() selectedValue: string;
  @Input() name: string;
  @Input() triggerOnClick = false;
  @Output() changeCallback = new EventEmitter();

  onInputChange(): void {
    if (!this.triggerOnClick && this.option)  {
      this.changeCallback.emit(this.option.value);
    }
  }

  OnSelect() {
    if(this.option){
      this.changeCallback.emit(this.option.value);
    }
  }
}
